import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusHeader, StatusTitle } from './StatusFilter.styles';
import { useStatus } from '../../hooks';
import { SurveyStatus } from '../../hooks/useStatus';
import Dropdown from '../Dropdown/Dropdown';
import FilterIcon from '@/assets/icons/filterIcon.svg?react';

interface IStatusFilter {
  appliedStatus: string | null;
  onFilterChange: (filter: string[]) => void;
}

const StatusFilter: FC<IStatusFilter> = ({ appliedStatus, onFilterChange }) => {
  const { getAppliedStatus } = useStatus();
  const { t } = useTranslation();
  const statusOptions = Object.values(SurveyStatus);

  return (
    <StatusHeader>
      <StatusTitle data-testid="status-header">
        {t('surveys.table.columnConfig.status')}
      </StatusTitle>
      <Dropdown
        selectedItems={appliedStatus ? getAppliedStatus(appliedStatus) : []}
        options={statusOptions}
        icon={<FilterIcon />}
        onSelect={filter => onFilterChange(filter)}
        onDeselect={filter => onFilterChange(filter)}
        style={{ minWidth: 160 }}
      />
    </StatusHeader>
  );
};

export default StatusFilter;
